module.exports = __webpack_public_path__ + "img/gw.7d29867d.svg";